import React, { FC } from 'react';

interface AutoLinkProps {
  text: string | undefined;
}

const AutoLink: FC<AutoLinkProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  const lineBreaks = (someString: string) => {
    return someString
      .split(/(\r\n|\n|\r)/gm)
      .map((line: string, index: number) =>
        line.match(/(\r\n|\n|\r)/gm) ? <br key={index} /> : line || null
      );
  };

  const emails = (someString: string) => {
    const delimiter =
      /([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)/g;

    return someString.split(delimiter).map((element: string) => {
      console.log();
      const match = element.match(delimiter);
      if (match) {
        const mail = match[0];
        return <a href={`mailto:${mail}`}>{mail}</a>;
      }
      // preserve link breaks
      return links(element);
    });
  };

  const links = (someString: string) => {
    const delimiter =
      /((?:https?:\/\/)?(?:(?:[a-z0-9]?(?:[a-z0-9\-]{1,61}[a-z0-9])?\.[^\.|\s])+[a-z\.]*[a-z]+|(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3})(?::\d{1,5})*[a-z0-9.,_\/~#&=;%+?\-\\(\\)]*)/gi;

    return someString.split(delimiter).map((word: string) => {
      const match = word.match(delimiter);
      if (match) {
        const url = match[0];
        return <a href={url.startsWith('http') ? url : `http://${url}`}>{url}</a>;
      }
      // preserve link breaks
      return lineBreaks(word);
    });
  };

  return <>{emails(text)}</>;
};

export default AutoLink;
